import { motion } from 'motion/react'

import { useStep } from '../../hooks/use-step'
import { Step } from '../../utils/steps'
import { TitleAndText } from '../title-and-text/title-and-text'

import style from './use-agent-skills-anywhere.module.scss'

export const UseAgentSkillsAnywhere = () => {
  const { step } = useStep()
  return (
    <>
      <div className={style.container}>
        <motion.div
          initial={{ opacity: 1, y: 0 }}
          animate={step === Step.GoTime ? { opacity: 0, y: '-30%' } : { opacity: 1 }}
          transition={{ delay: step === Step.GoTime ? 0.5 : 0 }}
          className={style.content}
        >
          <TitleAndText
            title="Use agent skills anywhere"
            text="You'll access your agents with the Go tab on the side of your browser."
          />
        </motion.div>
      </div>
      <div data-step={Step.UseAgentSkillAnyWhere}></div>
    </>
  )
}
